import { useDime } from '@office-start/dime-service';
import { useCallback, useMemo } from 'react';
import { useDimeTargetUrl } from './useDimeTargetUrl';
export var useDimeCallback = function (experience) {
    // Prefer dime from param. Fall back to built-in logic when no param is passed (dime is disabled or in SPAv2)
    var targetUrl = useDimeTargetUrl();
    var showDimeReact = useDime({
        experiences: [experience],
    });
    var showDimeCallback = useCallback(function () {
        if (showDimeReact) {
            showDimeReact(experience, targetUrl);
            return;
        }
    }, [experience, showDimeReact, targetUrl]);
    return useMemo(function () {
        if (showDimeReact) {
            return showDimeCallback;
        }
        return undefined;
    }, [showDimeCallback, showDimeReact]);
};
//# sourceMappingURL=useDimeCallback.js.map